import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Category10 from "../../components/category/Category10";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbcourse from "../../components/breadcrumbcourse";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../../CartContext";

Course.propTypes = {};

function Course(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

   const [reviews, setReviews] = useState([]);
const [ratingSummary, setRatingSummary] = useState({
  avg: 0,
  total: 0,
  breakdown: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }
});

   

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

 const { clientId } = useParams();
  const [category, setCategory] = useState([]);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-course-details/${clientId}`);
        setCategory(response.data); 
      } catch (error) {
        console.error("Error fetching course details:", error);
      }
    };

    fetchCourseDetails();
  }, [clientId]);

  const [data, setData] = useState([]);

useEffect(() => {
  if (category?.Csid && clientId) {
    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getcoursesbyidnotid/${category.Csid}/${clientId}`)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }
}, [category.Csid, clientId]);


   const [openTabs, setOpenTabs] = useState({
    tab1: false,
    tab2: true,
    tab3: false,
  });

  const toggleTab = (tab) => {
    setOpenTabs((prev) => ({
      ...prev,
      [tab]: !prev[tab],
    }));
  };


  const cardStyle = {
    flex: '1 1 100%',
    border: '1px solid #ccc',
    borderRadius: '1px',
    boxShadow: '2px 2px 6px rgba(0,0,0,0.1)',
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: '#003300',
    border: 'none',
    width: '100%',
    textAlign: 'left',
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: '1px',
    fontSize: '14px',
    color: "white",
  };

  const contentStyle = {
    padding: '16px',
    backgroundColor: '#fff',
    borderTop: '1px solid #ccc',
    fontSize: '14px',
  };

const [clients, setClients] = useState([]);
  useEffect(() => {
    if (!clientId) return; // Ensure clientId is available

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/curriculumsort/${clientId}`)
      .then((response) => {
        setClients(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);

   
  const [modalVideo, setModalVideo] = useState(null); // store selected video



const [language, setLanguage] = useState("en");
  
   const [clientsnew, setClientsnew] = useState([]);
  useEffect(() => {
    if (!clientId) return;

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/videosortdemo/${clientId}`)
      .then((response) => setClientsnew(response.data))
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);


  const [clientsnew1, setClientsnew1] = useState([]);
   useEffect(() => {
    if (!clientId) return;

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/videosortwithoutdemo/${clientId}`)
      .then((response) => setClientsnew1(response.data))
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);






  const [currentIndex, setCurrentIndex] = useState(null); // index of selected video

const openVideoModal = (videoSrc, index) => {
  setModalVideo(videoSrc);
  setCurrentIndex(index);
  setShowQuestions(false);
   // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
};

  const closeModal = () => {
    setModalVideo(null);
    setShowQuestions(false);
  };

  const handlePrev = () => {
  if (currentIndex > 0) {
    const newIndex = currentIndex - 1;
    setModalVideo(clientsnew[newIndex].Path1);
    setCurrentIndex(newIndex);
     setShowQuestions(false);
      // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
  }
};

const handleNext = () => {
  if (currentIndex < clientsnew.length - 1) {
    const newIndex = currentIndex + 1;
    setModalVideo(clientsnew[newIndex].Path1);
    setCurrentIndex(newIndex);
     setShowQuestions(false);
      // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
  }
};

const openQuestionsModal = (videoId) => {
  const filteredQuestions = clientslatestnew.filter(
    (q) => String(q.Videoid) === String(videoId)
  );

  setQuestionsForCurrentVideo(filteredQuestions);
  setShowQuestions(true);

  // No video for regular course questions
  setModalVideo(null);
  setCurrentIndex(null);

  setSelectedAnswers({});
  setSubmitted(false);
};
  

  // Following function calls questions related to Videos
 const [clientslatestnew, setClientslatestnew] = useState([]);
  useEffect(() => {
    if (!clientId) return; // Ensure clientId is available

    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/questionssort/${clientId}`)
      .then((response) => {
        setClientslatestnew(response.data); // Store response in state
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [clientId]);


const [questionsForCurrentVideo, setQuestionsForCurrentVideo] = useState([]);
const [showQuestions, setShowQuestions] = useState(false);

const handleVideoEnd = () => {
  const currentVideo = clientsnew[currentIndex];
  if (!currentVideo) return;

  console.log("currentVideo.Id:", currentVideo.Id);
  console.log("Available question Videoids:", clientslatestnew.map(q => q.Videoid));

  const filteredQuestions = clientslatestnew.filter(
    (q) => String(q.Videoid) === String(currentVideo.Id)
  );

  console.log("Filtered questions:", filteredQuestions);

  setQuestionsForCurrentVideo(filteredQuestions);
  setShowQuestions(true);

   // ✅ Reset states when moving to next video
  setSelectedAnswers({});
  setSubmitted(false);
    
};

const [selectedAnswers, setSelectedAnswers] = useState({});
const [submitted, setSubmitted] = useState(false);

const handleAnswerSelect = (questionId, option) => {
  setSelectedAnswers(prev => ({ ...prev, [questionId]: option }));
};

const handleSubmitAnswers = () => {
  setSubmitted(true);
};

  const navigate = useNavigate();
const { addToCart } = useContext(CartContext);

const handleBuyNow = () => {
  const userId = localStorage.getItem("userId");

  if (!userId) {
    localStorage.setItem("redirectAfterLogin", window.location.pathname);
    navigate("/login");
    return;
  }

  const courseItem = {
    Id: category.Id,
    Title: category.Title,
    Price: category.Price1,
    Validity: category.Validity,
  };

  addToCart(courseItem);
  navigate("/cart");
};

const [expandedIndex, setExpandedIndex] = useState(null);
const [expandedIndex2, setExpandedIndex2] = useState(null);

const toggleReadMore = (index) => {
  setExpandedIndex((prevIndex) =>
    prevIndex === index ? null : index
  );
};

const toggleReadMore2 = (index) => {
  setExpandedIndex2((prevIndex) =>
    prevIndex === index ? null : index
  );
};

const [expandedReviewIndex, setExpandedReviewIndex] = useState(null);

const toggleReviewReadMore = (index) => {
  setExpandedReviewIndex((prevIndex) =>
    prevIndex === index ? null : index
  );
};

  const MAX_LENGTH = 150; // characters to show initially

  const [alreadyPurchased, setAlreadyPurchased] = useState(false);
useEffect(() => {
  const checkPurchase = async () => {
    const storedUserId = localStorage.getItem("userId");

    // If not logged in, user definitely hasn't purchased
    if (!storedUserId || !clientId) {
      setAlreadyPurchased(false);
      return;
    }

    try {
      const res = await axios.get(
        `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/has-purchased-course/${clientId}/${storedUserId}`
      );

      setAlreadyPurchased(res.data.purchased === true);
    } catch (err) {
      console.error("Error checking purchase:", err);
      setAlreadyPurchased(false);
    }
  };

  checkPurchase();
}, [clientId]);

useEffect(() => {
  if (!clientId) return;

  const fetchReviews = async () => {
    try {
      console.log("CourseId received:", clientId);
      const res = await axios.get(
        `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/reviews-by-course/${clientId}`
      );

      const data = res.data || [];

      const breakdown = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

      let total = data.length;
      let sum = 0;

      data.forEach((r) => {
        const rating = Number(r.Rating);
        if (rating >= 1 && rating <= 5) {
          breakdown[rating]++;
          sum += rating;
        }
      });

      setReviews(data.slice(0, 5)); // latest 5 reviews

      setRatingSummary({
        avg: total ? (sum / total).toFixed(1) : 0,
        total,
        breakdown
      });

    } catch (err) {
      console.error("Error fetching reviews:", err);
    }
  };

  fetchReviews();
}, [clientId]);

const renderStars = (rating) => (
  <div style={{ display: "flex", gap: "2px" }}>
    {[1, 2, 3, 4, 5].map((n) => (
      <span key={n} style={{
        color: n <= Math.round(rating) ? "#ffc107" : "#ddd",
        fontSize: "16px"
      }}>
        ★
      </span>
    ))}
  </div>
);


const [reviewsMap, setReviewsMap] = useState({});
useEffect(() => {
  const fetchApprovedReviews = async () => {
    try {
      const res = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/reviews-approved-courses"
      );

      const map = {};

      res.data.forEach((r) => {
        map[Number(r.CourseId)] = {
          avg: r.avgRating,
          count: r.totalReviews
        };
      });

      setReviewsMap(map);

    } catch (err) {
      console.error("Error fetching course reviews:", err);
    }
  };

  fetchApprovedReviews();
}, []);





const handleViewDashboard = () => {
  navigate("/userdashboard");
};


  
  
  return (
    <>
  <Helmet>
  <title>{category?.Title ? `${category.Title} - Adhigyanam | Sauntesthyam LLP` : 'Loading... | Adhigyanam'}</title>
</Helmet>
      <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

        <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
          </div>
          <div className="header-customize-item button">
            <Link to="/login">My Account</Link>
          </div>

           <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
        </div>
      </div>
      
      <Header2 clname="act1" handleMobile={handleMobile} />
        <Breadcrumbcourse title={category.Title} />
     
         <section className="testimonials-category-section" style={{ paddingTop: "20px", paddingBottom:"20px" }}>
               <div className="tf-container">
                     <div className="row" style={{textAlign:"left", maxWidth:"1200px", margin:"auto"}}>
                         <div className="col-lg-8 col-12">
                         <h6 style={{marginTop:"20px", marginBottom:"5px", textAlign:"left", color:"#003300"}}>{category.Title}</h6> 
                         <p>By <b>{category.Ename}</b></p> 
                         <hr/>
                         
       <p>{category.Qdesc}</p> 
        
      
     <div style={{ marginTop:"20px", textAlign:"left", backgroundColor:"#fafafa", marginBottom:"20px"}}>
         
          <table style={{
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "20px",
  fontFamily: "Arial, sans-serif",
  fontSize: "15px",
  color: "#333"
}}>
  <tbody>
   
    <tr style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Language</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Lname}</td>
    </tr>
    <tr style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Study Material</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Smat}</td>
    </tr>
     <tr>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Doubt Clearing Session(s)</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.a11}</td>
    </tr>
    <tr>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Questionnaire</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.a22}</td>
    </tr>

     <tr>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9"
      }}>Course Validity</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Validity} Days</td>
    </tr>
    <tr style={{ borderBottom: "1px solid #ccc" }}>
  <td style={{
    padding: "5px 15px",
    fontWeight: "bold",
    border: "1px solid #ccc",
    backgroundColor: "#f9f9f9"
  }}>Course Fee</td>
  <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <span>{category.Price1} INR</span>
    {alreadyPurchased ? (
  <button
    onClick={handleViewDashboard}
    style={{
      padding: "6px 14px",
      backgroundColor: "#14a077",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      fontWeight: "600",
      cursor: "pointer", fontWeight:"bolder"
    }}
  >
    View in Dashboard
  </button>
) : (
  <button
    style={{
      padding: "6px 12px",
      backgroundColor: "black",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer"
    }}
    onClick={handleBuyNow}
  >
    Buy Now
  </button>
)}
    </div>
  </td>
</tr>
    <tr style={{ borderBottom: "1px solid #ccc" }}>
      <td style={{
        padding: "5px 15px",
        fontWeight: "bold",
        border: "1px solid #ccc",
        backgroundColor: "#f9f9f9",
        width: "30%"
      }}>Educator</td>
      <td style={{ padding: "5px 15px", border: "1px solid #ccc" }}>{category.Ename}</td>
    </tr>
   
  </tbody>
</table>
          </div>
<div style={{marginBottom:"20px", textAlign:"left"}}>
           <div className="accordion-card" style={cardStyle}>
          <button onClick={() => toggleTab('tab3')} style={headerStyle}>
            <span>Course Curriculum</span>
            <span>{openTabs.tab3 ? '−' : '+'}</span>
          </button>
          {openTabs.tab3 && (
            <div style={contentStyle}>
             <table className="table bordered-table sm-table mb-0" style={{width:"100%"}}>
                        
                                    <tbody>
  {clients.map(client => (
    <tr key={client.Id} style={{ borderBottom: "none", backgroundColor: "#f9f9f9", transition: "0.3s" }}>
      <td style={{ padding: "10px", fontSize: "0.9rem", color: "#333", backgroundColor: "white" }}><b>{client.Title}</b><br/>{client.Qdesc}</td>
    </tr>
  ))}
</tbody>
</table>
            </div>
          )}
        </div>
        </div>
<div style={{marginBottom:"20px", textAlign:"left"}}>
          <div className="accordion-card" style={cardStyle}>
          <button onClick={() => toggleTab('tab2')} style={headerStyle}>
            <span>Course Playlist</span>
            <span>{openTabs.tab2 ? '−' : '+'}</span>
          </button>
          {openTabs.tab2 && (
            <div style={contentStyle}>
             <style>{`
    .rich-content img {
      display: block;
      margin: 10px auto;
      max-width: 100%;
      height: auto;
      float: none !important;
      width: 100% !important;
    }

    .switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #ccc;
  transition: 0.3s;
  border-radius: 34px;
}

.slider:before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background: #0d6efd;
}

input:checked + .slider:before {
  transform: translateX(24px);
}
  `}</style>
<div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "15px",
  }}
>
  <span>English</span>

  <label className="switch">
    <input
      type="checkbox"
      checked={language === "hi"}
      onChange={(e) => setLanguage(e.target.checked ? "hi" : "en")}
    />
    <span className="slider"></span>
  </label>

  <span>हिन्दी</span>
</div>

                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
        
        <tbody>
          {clientsnew.map((client, index) => (
            <tr key={index} >
            <td style={{verticalAlign:"top", textAlign:"center", width:"30%"}}>
               <img
                          src={client.Path2 || "default-image.jpg"} // Use Path1 for image
                          alt={client.Title}
                          style={{ width: "100%", height: "auto", borderRadius: "5px" }}
                        />

                         
            </td>
              <td  style={{verticalAlign:"top", width:"70%"}}>
                <p style={{marginBottom:"5px", paddingLeft:"10px"}}><strong>
  {language === "hi" ? client.Title2 : client.Title}
</strong></p>
                 <p style={{ whiteSpace: "pre-wrap", paddingLeft: "10px" }}>
  {language === "hi"
    ? (expandedIndex === index
        ? client.Qdesc2
        : `${client.Qdesc2.slice(0, MAX_LENGTH)}... `)
    : (expandedIndex === index
        ? client.Qdesc
        : `${client.Qdesc.slice(0, MAX_LENGTH)}... `)}

  <span
    onClick={() => toggleReadMore(index)}
    style={{
      color: "green",
      cursor: "pointer",
      fontWeight: "bold"
    }}
  >
    {language === "hi"
      ? (expandedIndex === index ? "कम पढ़ें" : "और पढ़ें")
      : (expandedIndex === index ? "Read less" : "Read more")}
  </span>
</p>
               <div style={{ float: "right", marginTop: "6px", display: "flex", gap: "8px" }}>
  
  {/* Watch Free Video */}
  <p
    onClick={() => openVideoModal(client.Path1, index)}
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 14px",
      backgroundColor: "#e8f0fe",
      color: "#0b57d0",
      fontWeight: "700",
      fontSize: "0.8rem",
      borderRadius: "6px",
      cursor: "pointer"
    }}
  >
   {language === "hi" ? "▶ निःशुल्क देखें" : "▶ Watch for FREE"}
  </p>

  {/* Practice Questions (FREE ONLY) */}
  <p
    onClick={() => openQuestionsModal(client.Id)}
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 14px",
      backgroundColor: "#e6fff2",
      color: "#003300",
      fontWeight: "700",
      fontSize: "0.8rem",
      borderRadius: "6px",
      cursor: "pointer"
    }}
  >
    {language === "hi" ? "📝 क्विज़ शुरू करें" : "📝 Start Quiz"}
  </p>

</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

               <table style={{ width: "100%", borderCollapse: "collapse" }}>
        
        <tbody>
          {clientsnew1.map((client, index) => (
            <tr key={index} >
            <td style={{verticalAlign:"top", textAlign:"center", width:"30%"}}>
               <br/><img
                          src={client.Path2 || "default-image.jpg"} // Use Path1 for image
                          alt={client.Title}
                          style={{ width: "100%", height: "auto", borderRadius: "5px" }}
                        />

                         
            </td>
              <td  style={{verticalAlign:"top", width:"70%"}}>
                <br/><p style={{marginBottom:"5px", paddingLeft:"10px"}}><strong>
  {language === "hi" ? client.Title2 : client.Title}
</strong></p>
                <p style={{ whiteSpace: "pre-wrap", paddingLeft: "10px" }}>
  {language === "hi"
    ? (expandedIndex2 === index
        ? client.Qdesc2
        : `${client.Qdesc2.slice(0, MAX_LENGTH)}... `)
    : (expandedIndex2 === index
        ? client.Qdesc
        : `${client.Qdesc.slice(0, MAX_LENGTH)}... `)}

  <span
    onClick={() => toggleReadMore2(index)}
    style={{
      color: "green",
      cursor: "pointer",
      fontWeight: "bold"
    }}
  >
    {language === "hi"
      ? (expandedIndex2 === index ? "कम पढ़ें" : "और पढ़ें")
      : (expandedIndex2 === index ? "Read less" : "Read more")}
  </span>
</p>
               
              </td>
            </tr>
          ))}
        </tbody>
      </table>




      {/* Video Modal */}
   {(modalVideo || showQuestions) && (
  <div style={modalOverlay} onClick={closeModal}>
    <div
      style={modalContent}
      onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
    >
      {/* Close Button - OUTSIDE and ABOVE video */}
      <div style={closeWrapper}>
        <span style={closeBtn} onClick={closeModal}>&times;</span>
      </div>

     {modalVideo && (
  <video
    src={modalVideo}
    controls
    controlsList="nodownload"
    style={{ width: "100%", borderRadius: "8px" }}
    autoPlay
    onContextMenu={(e) => e.preventDefault()}
    onEnded={handleVideoEnd}
  />
)}
{showQuestions && questionsForCurrentVideo.length > 0 && (
  <div className="question-container" style={{padding:"10px", maxHeight:"300px", overflowY:"scroll"}}>
  <p style={{marginBottom:"15px", backgroundColor:"#f0fff0", padding:"5px", border:"solid #f2f2f2 thin"}}><b>Test Your Learning - Quiz</b><br/>Following quick Q&A session will help you determine your current learning curve and revision of core course concepts.</p>
    {questionsForCurrentVideo.map((q, index) => (
      <div key={q.Id} style={{marginBottom:"16px", borderBottom: "1px solid #ccc", paddingBottom: "10px"}}>
        <p><strong>{index + 1}. {q.Title}</strong></p>
        <p>{q.Qdesc}</p>
        <table style={{width:"100%"}}>
          {['A', 'B', 'C', 'D'].map((opt) => {
            const optionText = q[`Option${opt.toLowerCase()}`];
            const isSelected = selectedAnswers[q.Id] === opt;
            const isCorrect = q.Result === opt;
            const showFeedback = submitted;

            return (
              <tr key={opt}>
                <td
                  onClick={() => handleAnswerSelect(q.Id, opt)}
                  style={{
                    padding: "0px 10px",
                    cursor: "pointer",
                    backgroundColor: showFeedback
                      ? isSelected
                        ? isCorrect
                          ? "#d4edda" // green for correct
                          : "#f8d7da" // red for wrong
                        : isCorrect
                        ? "#d4edda" // show correct even if not selected
                        : "transparent"
                      : isSelected
                      ? "#cce5ff"
                      : "transparent",
                    borderRadius: "4px"
                  }}
                >
                  {opt}. {optionText}
                </td>
              </tr>
            );
          })}
        </table>
        {submitted && (
          <p style={{marginTop: "5px"}}>
            Your answer: <strong>{selectedAnswers[q.Id] || "Not answered"}</strong> | Correct: <strong>{q.Result}</strong>
          </p>
        )}
      </div>
    ))}

    {!submitted && (
      <button onClick={handleSubmitAnswers} style={{marginTop: "0px", padding: "10px 15px", cursor: "pointer", float:"right", backgroundColor:"#003300", color:"white", border:"none", borderRadius:"3px"}}>
        Submit Your Answers
      </button>
    )}
  </div>
)}
    </div>
  </div>
)}
            </div>
          )}
        </div>
        </div>

       

<div style={{marginBottom:"20px", textAlign:"left"}}>
  <div className="accordion-card" style={cardStyle}>
          <button onClick={() => toggleTab('tab1')} style={headerStyle}>
            <span>Learning Milestones</span>
            <span>{openTabs.tab1 ? '−' : '+'}</span>
          </button>
          {openTabs.tab1 && (
            <div style={contentStyle}>
             <table className="table bordered-table sm-table mb-0" style={{width:"100%"}}>
                        
                                    <tbody>
                                     <div
       style={{ marginBottom: "0px", marginTop: "0px", textAlign: "left" }}
       dangerouslySetInnerHTML={{ __html: category.Sdesc }}
     ></div>

</tbody>
</table>
            </div>
          )}
        </div>
</div>



  <div
       style={{ marginBottom: "5px", marginTop: "10px", textAlign: "left" }}
       dangerouslySetInnerHTML={{ __html: category.Fdesc }}
     ></div>

    

      <div style={{
  maxWidth: "100%",
  margin: "12px auto",
  padding: "20px",
  border: "1px solid #ddd",
  borderRadius: "12px",
  boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
  backgroundColor: "#fafafa",
  textAlign: "center",
  fontFamily: "Arial, sans-serif"
}}>
  <h2 style={{
    color: "#333",
    marginBottom: "10px",
    fontSize: "22px"
  }}>
    Ready to Elevate Your Learning?
  </h2>
  <p style={{
    color: "#555",
    fontSize: "16px",
    marginBottom: "10px"
  }}>
    Enroll in <strong>{category?.Title}</strong> today and unlock expert insights, curated material, and structured learning — all designed to fast-track your success.
  </p>
 {alreadyPurchased ? (
  <button
    onClick={handleViewDashboard}
    style={{
      padding: "10px 24px",
      fontSize: "14px",
      backgroundColor: "#14a077",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer", fontWeight:"bolder"
    }}
  >
    View in Dashboard
  </button>
) : (
  <button
    onClick={handleBuyNow}
    style={{
      padding: "10px 24px",
      fontSize: "14px",
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer"
    }}
  >
    Buy Now
  </button>
)}
</div>




                        
                         </div>
                         <div className="col-lg-4 col-12">

                         <div className="box-content"  style={{textAlign:"left", marginTop:"25px"}}>
                          <div style={{
  marginTop: "20px",
  padding: "20px",
  background: "#fff",
  borderRadius: "10px",
  border: "1px solid #eee", marginBottom:"20px"
}}>

  <h6 style={{ marginBottom: "15px" }}>Ratings & Reviews</h6>

  {/* TOP SUMMARY */}
  <div style={{ display: "flex", gap: "30px", alignItems: "center", flexWrap: "wrap" }}>

    {/* Left: Avg Rating */}
    <div style={{ textAlign: "center" }}>
      <h1 style={{ margin: 0 }}>{ratingSummary.avg}</h1>
      {renderStars(ratingSummary.avg)}
      <p style={{ fontSize: "12px", color: "#666" }}>
        {ratingSummary.total} reviews
      </p>
    </div>

    {/* Right: Breakdown */}
    <div style={{ flex: 1 }}>
      {[5,4,3,2,1].map((star) => {
        const count = ratingSummary.breakdown[star];
        const percent = ratingSummary.total
          ? (count / ratingSummary.total) * 100
          : 0;

        return (
          <div key={star} style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "6px"
          }}>
            <span style={{ width: "20px" }}>{star}★</span>

            <div style={{
              flex: 1,
              height: "8px",
              background: "#eee",
              borderRadius: "5px"
            }}>
              <div style={{
                width: `${percent}%`,
                height: "100%",
                background: "#ffc107",
                borderRadius: "5px"
              }} />
            </div>

            <span style={{ fontSize: "12px", width: "30px" }}>
              {count}
            </span>
          </div>
        );
      })}
    </div>

  </div>


  {/* RECENT REVIEWS */}
  {/* RECENT REVIEWS */}
<div style={{ marginTop: "15px" }}>
  {reviews.length > 0 ? (
    reviews.map((r, index) => (
      <div
        key={index}
        style={{
          marginBottom: "15px"
        }}
      >

        <strong>Registered User</strong>

        {renderStars(r.Rating)}

        {/* Review Feedback */}
        {(() => {
          const feedback = String(
            r.Feedback || "No comment provided"
          ).trim();

          const maxReviewLength = 180;
          const isLongReview = feedback.length > maxReviewLength;
          const isExpanded = expandedReviewIndex === index;

          const displayedFeedback =
            isLongReview && !isExpanded
              ? `${feedback.substring(0, maxReviewLength).trim()}...`
              : feedback;

          return (
            <p
              style={{
                margin: "5px 0",
                fontSize: "14px",
                lineHeight: "1.6"
              }}
            >
              {displayedFeedback}

              {isLongReview && (
                <>
                  {" "}
                  <button
                    type="button"
                    onClick={() => toggleReviewReadMore(index)}
                    style={{
                      border: "none",
                      background: "none",
                      padding: 0,
                      margin: 0,
                      color: "#14a077",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer"
                    }}
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                  </button>
                </>
              )}
            </p>
          );
        })()}

        <p
          style={{
            fontSize: "11px",
            color: "#999"
          }}
        >
          {new Date(r.CreatedAt).toLocaleDateString()}
        </p>

      </div>
    ))
  ) : (
    <p style={{ color: "#999" }}>No reviews yet</p>
  )}
</div>

</div>
                       <h3 style={{ marginBottom: "15px", fontSize: "16px", display: 'flex', textTransform:"uppercase", 
    justifyContent: 'space-between' }}>
       <b>Browse By Category</b>
     </h3>
     <hr/>
     <ul style={{paddingLeft:"20px"}}>
            {categoriesnew2.length > 0 ? (
               categoriesnew2.map((categories, index) => (
                 <li key={index} className="menu-item menu-item-mobile">
                   <Link to={`/blog-category-details/${categories.Id}`}  style={{color:"#14a077", fontSize:"15px", lineHeight:"16px", fontWeight:"bold"}}>{categories.Named}</Link> {/* 'Named' column from the database */}
                 </li>
               ))
             ) : (
               <li className="menu-item menu-item-mobile">
                 <span>No categories available</span>
               </li>
             )}          
     </ul>
           <h3 style={{ marginTop:"30px", marginBottom: "15px", fontSize: "16px", display: 'flex', textTransform:"uppercase", 
    justifyContent: 'space-between' }}>
       <b>Trending Courses</b>
     </h3>
     <hr/>
             {data.map((item, index) => {
  const reviewData = reviewsMap[Number(item.Id)];

  return (
    <div key={index} className="col-12">
      <div
        className="group-category-job padding wow fadeInUp"
        style={{ paddingBottom: "10px", marginTop: "25px" }}
      >
        <Link to={`/course/${item.Id}`}>
          <div
            className="job-category-box"
            style={{ width: "unset", padding: "18px" }}
          >
            <div className="job-category-header" style={{ marginBottom: "0px" }}>
              
              {/* Image */}
              <img
                src={item.Path1 || "default-image.jpg"}
                alt={item.Title}
                style={{ width: "100%", height: "auto", borderRadius: "10px" }}
              />

              {/* Title */}
              <h1
                style={{
                  marginTop: "15px",
                  fontWeight: "600",
                  fontSize: "16px",
                  marginBottom: "5px"
                }}
              >
                <Link to={`/course/${item.Id}`}>{item.Title}</Link>
              </h1>

              {/* ⭐ Ratings */}
              {reviewData ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginBottom: "8px"
                  }}
                >
                  {renderStars(Number(reviewData.avg))}

                  <span style={{ fontSize: "12px", color: "#6b7280" }}>
                    ({Number(reviewData.avg).toFixed(1)}) • {reviewData.count} review(s)
                  </span>
                </div>
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#9ca3af",
                    display: "block",
                    marginBottom: "8px"
                  }}
                >
                  New Course
                </span>
              )}

              {/* Description */}
              <p style={{ marginBottom: "10px" }}>{item.Qdesc}</p>

              {/* Price */}
              <p>
                <b>Course Fee</b>: {item.Price1} INR -{" "}
                <b>Validity</b>: {item.Validity} Days
              </p>
            </div>

            {/* Button */}
            <Link
              to={`/course/${item.Id}`}
              className="btn-category-job"
              style={{ marginTop: "5px" }}
            >
              View Details
              <span className="icon-keyboard_arrow_right"></span>
            </Link>
          </div>
        </Link>
      </div>
    </div>
  );
})}
     
                        
                       </div>
     
     </div>
                         </div>
                        
               </div>
             </section>
      
      <div
                className="floating-buttons"
                style={{
                  position: "fixed",
                  bottom: "20px",
                  left: "20px",
                  zIndex: "1000",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {/* Call Button */}
                <a
                  href={`tel:+918960708425`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#007BFF",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaPhoneAlt />
                </a>
              
                {/* WhatsApp Button */}
                <a
                  href={`https://wa.me/918960708425`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#25D366",
                    borderRadius: "50%",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                    color: "white",
                    fontSize: "28px",
                  }}
                >
                  <FaWhatsapp />
                </a>
              </div>
      <Footer />
      <Gotop />
    </>
  );
}

// Modal styles
const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalContent = {
  position: "relative",
  background: "white",
  padding: "0.5rem",
  borderRadius: "3px",
  width: "80%",
  maxWidth: "600px",
  boxShadow: "0 0 20px rgba(0,0,0,0.5)",
  paddingBottom:"0.1rem",
};

const closeWrapper = {
  position: "absolute",
  top: "-25px",
  right: "-25px",
  zIndex: 10000,
  background: "black",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
  cursor: "pointer",
};

const closeBtn = {
  fontSize: "2rem",
  color: "white",
  lineHeight: "1",
  marginTop:"-10px",
};

export default Course;
